const ACTIONS = {
    SETURI_FOTOPERFIL: 'SETURI_FOTOPERFIL',
    NOTFOUND_FOTOPERFIL: 'NOTFOUND_FOTOPERFIL'
};
const INITIAL_STATE = {
    uri: ''
};
export function FotoPerfilReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.SETURI_FOTOPERFIL:
            return { ...state, uri: action.uri };
        case ACTIONS.NOTFOUND_FOTOPERFIL:
            return { ...state, uri: '' };
        default:
            return state;
    }
}
